import * as React from 'react'
import type { DialogProps as MaterialDialogProps } from 'material-ui'
import MaterialDialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import { Base_Component } from '../Base/Base.ui.Component'
import { DS_setData } from '../DS/DS.Data'
import { DS_Listen } from '../DS/DS.ui.Listen'
import { Translations } from '../../../shared/i18n/Translations'

export function UI_dialogOk(title: string, content: React.ReactNode) {
    const actions = [
        <FlatButton
            label={Translations.t('app:common.ok')}
            primary={true}
            keyboardFocused={true}
            onClick={UI_dialogClose}
        />,
    ]
    UI_dialogOpen({ title, actions }, <div>{content}</div>)
}

export function UI_dialogOkCancel(title: string, content: React.ReactNode, onOk: () => void) {
    const actions = [
        <FlatButton label={Translations.t('app:common.cancel')} onClick={UI_dialogClose} />,
        <FlatButton label={Translations.t('app:common.ok')} primary={true} keyboardFocused={true} onClick={onOk} />,
    ]
    UI_dialogOpen({ title, actions }, <div>{content}</div>)
}

export function UI_dialogSpinner(title: string) {
    UI_dialogOpen({ title }, <div className="AppCore__ui__Pulse" />)
}

export function UI_dialogOpen(props: Partial<MaterialDialogProps>, content: React.ReactNode) {
    DS_setData('DialogOpen', () => ({
        dialog: {
            props: {
                onRequestClose: UI_dialogClose,
                ...props,
                open: true,
            },
            content,
        },
    }))
}

export function UI_dialogClose() {
    DS_setData('DialogClose', () => ({
        dialog: {
            props: { open: false },
            content: null,
        },
    }))
}

export class UI_Dialog extends Base_Component<{}, {}> {
    public tryRender() {
        return DS_Listen(
            (d) => d.dialog,
            (dialog) => <MaterialDialog {...dialog.props}>{dialog.content}</MaterialDialog>
        )
    }
}
